
import QuoteDownSquare from "../../../assets/filled/QuoteDownSquare.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function QuoteDownSquareIcon({ className, dataTestid = "QuoteDownSquareIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <QuoteDownSquare data-testid={dataTestid} className={classes} {...rest} />
  );
}
